import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
} from '@/lib/graphql-query-builder';

export const buildGetQuantitativeDataQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    QuantitativeDatas: getQuantitativeDatas(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ProjectId
        ProjectName
        CustomerName
        ThisYearYTDRevenue
        ThisYearTgtRevenue
        LastYearYTDRevenue
        LastYearTgtRevenue
        ThisYearYTDGP
        ThisYearTgtGP
        ThisYearYTDNP
        ThisYearTgtNP
        ThisYearYTDNPMargin
        ThisYearTgtNPMargin
        ThisYearYTDNPS
        ThisYearTgtNPS
        ThisYearYTDRevenueGrowth
        ThisYearTgtRevenueGrowth
      }
    }
  }
`;

/**
 * Scoring weights are saved as history rows (append-only — see hr-kpi-configuration's `buildGetKpiConfigurationQuery`,
 * same schema); the newest one is the active configuration. Newest first, like the old
 * `KpiConfigurationService.GetLatestEntity` (`OrderByDescending(CreateDate)`), so a one-row page is the latest.
 */
export const buildGetLatestKpiConfigurationQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    KpiConfigurations: getKpiConfigurations(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral([{ field: 'CreatedDate', direction: 'DESC' }])}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      items {
        CreatedDate
        QnMatrixMinLevel
        QnMatrixMaxLevel
        NormalizedMaxScale
        ReviewerGroupWeightsJson
        CategoryWeightsJson
      }
    }
  }
`;
